import { AesService } from './aes.service';
import { Injectable } from '@angular/core';
import { Constants } from '../helpers/messages';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(private aes: AesService) {
  }
  
  public getUserId(){
    let rawid = this.getFromStore(Constants.LOGIN_USER);
    if(rawid){
      let user_id = rawid.id
      return (+user_id)
    }
  }

  public getClientId(){
    let rawid = this.getFromStore(Constants.LOGIN_USER);
    if(rawid){
      let client_id = rawid.clientid
      return client_id
    }
  }
  public getAppCode(){
    let rawid = this.getFromStore(Constants.LOGIN_USER);
    if(rawid){
      let appcode = rawid.appcode
      return appcode
    }
  }

  public getOnboardingPrivilege(){
    let rawid = this.getFromStore(Constants.LOGIN_USER);
    if(rawid){
      let client_id = rawid.canaddcompany
      return client_id
    }
    
  }

  public getLocationCode(){
    let user = this.getFromStore(Constants.LOGIN_USER);
    if(user){
      let location = user.locationcode
      return location
    }
  }

  public getRoleType(){
    let user = this.getFromStore(Constants.LOGIN_USER);
    if(user){
      let role = user.roletype    
      return role
    }
    
  }

  public getRoleList() {
    let user = this.getFromStore(Constants.LOGIN_USER);
    if(user){
      let rolelist = user.roles
      return rolelist
    }
  }
  
  public getUsername(){
    let usern = this.getFromStore(Constants.LOGIN_USER);    
    let username = usern.userName
    return username
  }

  public getClientname(){
    let usern = this.getFromStore(Constants.LOGIN_USER);
    if(usern){
      let username = usern.companyname
      return username
    }
  }

  public getClientPhonenumber(){
    let usern = this.getFromStore(Constants.LOGIN_USER);
    if(usern){
      let username = usern.phoneno
      return username
    }
  }

  public getSector() {
    let sector = this.getFromStore(Constants.LOGIN_USER);
    if(sector){
      let sect = sector.sector.description
      return sect
    }
  }
  
  public saveToStore(key:string, data:any){
    let encrypt = this.aes.encrypt(JSON.stringify(data));
    localStorage.setItem(key, encrypt);
    // localStorage.setItem(key, JSON.stringify(data));
  }

  public removeFromStore(key:string){
    localStorage.removeItem(key)
  }

  public getFromStore(key:string){
    let store = localStorage.getItem(key);

    if(store){
      let decrypt = this.aes.decrypt(store)
      return JSON.parse(decrypt)
    }
  }
  
  setToken(data) {
    this.saveToStore(Constants.TOKEN, data)
  }

  getToken() {
    return this.getFromStore(Constants.TOKEN)
  }

}
